import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiResponse } from '../../../models/api-response.model';
import { SelectCustomer } from '../../../models/select-customer.model';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { CustomerUsageService } from '../../services/customer-usage.service';

@Component({
  selector: 'app-search-customer',
  templateUrl: './search-customer.component.html',
  styleUrls: ['./search-customer.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class SearchCustomerComponent implements OnInit {
  customerList!: SelectCustomer[];
  srchCustomerForm!: FormGroup;
  chckCustomerForm!: FormGroup;
  apires!: ApiResponse;
  msgs: any[] = [];
  selectedCustomer: any[] = [];
  btnDisable = false;

  @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selCustomer: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeSearchnav = new EventEmitter<boolean>();

  constructor(
    private service: CustomerUsageService,
    private formBuilder: FormBuilder,
    public settings: SettingsService
  ) {}

  ngOnInit() {
    this.btnDisable = false;

    this.srchCustomerForm = this.formBuilder.group({
      txtCustomerSrch: ['', [Validators.required]]
    });

    this.chckCustomerForm = this.formBuilder.group({
      tenantID: ['']
    });
  }

  cancelSearchNav() {
    this.closeSearchnav.emit(false);
    this.msgs = [];
  }

  search() {
    this.isLoading.emit(true);
    if (this.srchCustomerForm.controls['txtCustomerSrch'].value.length > 2) {
      this.service
        .searchCustomer(
          this.srchCustomerForm.controls['txtCustomerSrch'].value,
          this.settings.AliasName as string
        )
        .subscribe(messageResponse => {
          this.customerList = messageResponse;
          if (messageResponse.length === 0) {
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: 'No Record Found'
            } as any);
            setTimeout(() => {
              this.msgs = [];
            }, 1000);
          }
          this.isLoading.emit(false);
        });
    } else {
      this.msgs = [];
      this.msgs.push({
        severity: 'warn',
        detail: 'Search With Three Letter words. ie. "mic"'
      } as any);

      setTimeout(() => {
        this.msgs = [];
      }, 3000);
      this.isLoading.emit(false);
    }
  }

  onSubmit() {
    this.selCustomer.emit(this.selectedCustomer);
    if (this.selectedCustomer.length > 0) {
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please Select Customer'
      } as any);
      setTimeout(() => {
        this.msgs = [];
      }, 2000);
    } else {
      this.msgs = [];
      this.btnDisable = true;
      this.msgs.push({
        severity: 'success',
        detail: 'Customer Added Successfully'
      } as any);
      setTimeout(() => {
        this.selCustomer.emit(this.selectedCustomer);
        this.msgs = [];
        this.selectedCustomer = [];
        this.cancelSearchNav();
      }, 1000);
      this.srchCustomerForm.reset();
      this.customerList = [];
    }
  }
}
